import { useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import './index.css';
import './assets/styles/scss/main.scss';
import './assets/styles/css/tailwind.css';
import Routes from './routes';
import { useEffect } from 'react';
import { getThemeStorage, getUserStorage } from './utils/localStorage';
import { decryptData } from './utils/cryptoJs';
import { DefaultTheme, blueTheme } from './assets/styles/theme';
import { useRecoilValue } from 'recoil';
import { themeColorState } from './recoil/states/default';
import ReactGA from 'react-ga4';

function App () {
  const history = useNavigate();
  const location = useLocation();
  if (!window.location.hostname?.toLowerCase().includes('uat-jobs')
    && !window.location.hostname?.toLowerCase().includes('localhost')) {
    console.log = console.warn = console.error = () => { };
  }
  const themeColor = useRecoilValue(themeColorState);
  ReactGA.initialize(process.env.REACT_APP_GA_ID);

  useEffect(() => {
    const _themeStorage = getThemeStorage();
    const root = document.documentElement;
    const _theme = themeColor === 'red' || _themeStorage === 'red';
    const _primary = _theme ? DefaultTheme.primary : blueTheme.primary;
    const _secondary1 = _theme ? DefaultTheme.secondary1 : blueTheme.secondary1;
    const _secondary2 = _theme ? DefaultTheme.secondary2 : blueTheme.secondary2;
    root?.style.setProperty('--color-primary', _primary);
    root?.style.setProperty('--color-secondary1', _secondary1);
    root?.style.setProperty('--color-secondary2', _secondary2);
    console.log('Theme Red Color :', _theme);
  }, [themeColor]);

  useEffect(() => {
    const user = getUserStorage();
    let isOtp = false;
    if (user && user.checkLogin) {
      const decryptedData = decryptData(user.checkLogin);
      if (decryptedData) {
        isOtp = decryptedData.isOtp //&& new Date().getTime() <= decryptedData.expiry;
      }
    }

    if (!isOtp && (location.pathname.toLowerCase().includes('myjob') || location.pathname.toLowerCase().includes('applicantprofile'))) {
      history('/');
    }
  }, []);

  useEffect(() => {
    let page = 'สภากาชาดไทย'
    if (location?.pathname?.toLowerCase().includes('myjob')) {
      page = 'ประวัติการสมัครงาน'
    } else if (location?.pathname?.toLowerCase().includes('applicantprofile')) {
      page = 'ใบสมัครงานของฉัน'
    } else if (location?.pathname?.toLowerCase().includes('jobdetail')) {
      page = 'รายละเอียดประกาศรับสมัครงาน'
    }
    ReactGA.send({ hitType: "pageview", page: `/${page}`, title: page });
  }, [location]);

  return (
    <Routes />
  );
}

export default App;
